<app-navbar-two></app-navbar-two>
<!DOCTYPE html>
<html lang="en">
<head>
    <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap" rel="stylesheet">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css">
    </head>
<div class="main-banner-area-three">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <div class="main-banner-content">
                            <!-- <span>Digital Marketing</span> -->
                            <!-- <h1>Digital Agency & Marketing</h1> -->
                            <!-- <span>Welcome To App Showcase</span> -->
                          <h1 >Empowering Your Digital Future with Innovative IT Solutions</h1>

                            <h5 style="color: #D11717;">Top-tier Software Solutions for Web, Mobile, and Desktop Platforms</h5>
                            <p>Alphurious Technologies is a trusted software development company committed to delivering
                                high-quality, scalable, and timely solutions tailored to your business needs. Whether
                                it's mobile, web, or desktop applications, we bring innovation, precision, and
                                dedication to every project. Our work speaks for itself — and our results drive your
                                success.</p>
                            <!-- <div class="banner-btn">
                                <a routerLink="/" class="default-btn">Get Started</a>
                            </div> -->
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="banner-image">
                            <img src="assets/img/home-three/1.png" class="wow animate__animated animate__fadeInUp"
                                data-wow-delay="0.6s" alt="image">
                            <img src="assets/img/home-three/2.png" class="wow animate__animated animate__fadeInDown"
                                data-wow-delay="0.6s" alt="image">
                            <img src="assets/img/home-three/3.png" class="wow animate__animated animate__fadeInUp"
                                data-wow-delay="0.6s" alt="image">
                            <img src="assets/img/home-three/4.png" class="wow animate__animated animate__fadeInDown"
                                data-wow-delay="0.6s" alt="image">
                            <img src="assets/img/home-three/5.png" class="wow animate__animated animate__zoomIn"
                                data-wow-delay="0.6s" alt="image">
                            <img src="assets/img/home-three/main.png" class="wow animate__animated animate__zoomIn"
                                data-wow-delay="0.6s" alt="image">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="default-shape">
        <div class="shape-1"><img src="assets/img/shape/4.png" alt="image"></div>
        <div class="shape-2 rotateme"><img src="assets/img/shape/5.svg" alt="image"></div>
        <div class="shape-3"><img src="assets/img/shape/6.svg" alt="image"></div>
        <div class="shape-4"><img src="assets/img/shape/7.png" alt="image"></div>
        <div class="shape-5"><img src="assets/img/shape/8.png" alt="image"></div>
    </div>
</div>

<section class="services-section bg-color pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>Our <span style="color: #D11717;">Awesome</span> Services</h2>
            <p style="max-width: 80%;">At Alphurious Technologies, we deliver high-quality software solutions to businesses of all sizes across
                the globe. Our experienced team provides domain-specific technology consulting for B2B, B2C, and B2B2C
                platforms. We focus on excellence, not volume — ensuring every project receives the care, precision, and
                innovation it deserves.</p>
            <div class="bar" style="background-color: #D11717;"></div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="icon">
                        <i class="flaticon-it"></i>
                    </div>
                    <!-- <h3>IT Consultancy</h3> -->
                    <h3>Desktop Development</h3>
                    <p>Extensive experience in Desktop applications using different tech-stacks to meet the industry
                        demand & standards.</p>
                    <!-- <a routerLink="/services-details" class="read-btn">Read More</a> -->
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="icon bg-deb0fe">
                        <i class="flaticon-setting"></i>
                    </div>
                    <h3>Web Development</h3>
                    <p>Highly experienced team of developers to deliver a customized, responsive design, excellent
                        performance & a secured application.</p>
                    <!-- <a routerLink="/services-details" class="read-btn">Read More</a> -->
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="icon bg-79e8e2">
                        <i class="flaticon-happy"></i>
                    </div>
                    <!-- <h3>Digital Marketing</h3> -->
                    <h3>Cloud Computing</h3>
                    <p>Cloud computing enables secure, scalable, and on-demand access to computing resources over the
                        internet.</p>
                    <!-- <a routerLink="/services-details" class="read-btn">Read More</a> -->
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="icon bg-fcc774">
                        <i class="flaticon-cellphone"></i>
                    </div>
                    <h3>Product Development</h3>
                    <p>Developed products using different types of domains like healthcare, e-Commerce, Insurance &
                        retailer etc.</p>
                    <!-- <a routerLink="/services-details" class="read-btn">Read More</a> -->
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="icon bg-84b7fd">
                        <i class="flaticon-shopping-cart"></i>
                    </div>
                    <h3>E-commerce Development</h3>
                    <p>In-house experts for development of websites and mobile apps for all types of devices which serve
                        as per market needs.</p>
                    <!-- <a routerLink="/services-details" class="read-btn">Read More</a> -->
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="icon bg-fe929f">
                        <i class="flaticon-optimize"></i>
                    </div>
                    <h3>IT Solutions</h3>
                    <p>Deal with IT services like Cybersecurity, Cloud computing, Artificial intelligence, Internet of
                        Things (IoT), Analytics, Machine learning etc.</p>
                    <!-- <a routerLink="/services-details" class="read-btn">Read More</a> -->
                </div>
            </div>
        </div>
    </div>

    <div class="default-shape">
        <div class="shape-1"><img src="assets/img/shape/4.png" alt="image"></div>
        <div class="shape-2 rotateme"><img src="assets/img/shape/5.svg" alt="image"></div>
        <div class="shape-3"><img src="assets/img/shape/6.svg" alt="image"></div>
        <div class="shape-4"><img src="assets/img/shape/7.png" alt="image"></div>
        <div class="shape-5"><img src="assets/img/shape/8.png" alt="image"></div>
    </div>
</section>

<section class="audience-section ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="audience-image">
                    <img src="assets/img/audience.png" alt="image">
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="audience-content">
                    <h3>Engaging New <span style="color: #D11717;">Audience</span> Through Smart Approach</h3>
                    <div class="bar" style="background-color: #D11717;"></div>
                    <p>At Alphurious Technologies, we specialize in delivering innovative software solutions that
                        connect businesses with their target audience through strategic, data-driven, and user-centric
                        approaches. Whether it's AI-driven healthcare platforms, scalable e-commerce solutions, or
                        intuitive mobile applications, our focus is on creating seamless digital experiences that drive
                        engagement, enhance brand value, and support sustainable growth. By combining cutting-edge
                        technology with deep industry insight, we help clients reach and retain the right
                        audience—smarter and faster.</p>
                    <ul>
                        <p><strong>Why Customer Choose Alphurious Technologies:</strong>

                            <li>AI-Driven Healthcare Solutions – Transforming patient care and operations with smart,
                                automated systems.</li>
                            <li>End-to-End E-Commerce Platforms – From product listing to secure checkout, built for
                                scale
                                and speed.</li>
                            <li>Custom Mobile App Development – High-performance apps tailored for Android, iOS, and
                                cross-platform needs.</li>
                            <li>Data-Driven Decision Making – Insightful analytics and BI tools to help businesses grow
                                with confidence.</li>
                            <li>Agile & Scalable Architecture – Solutions built for flexibility, future growth, and
                                seamless integration.</li>
                        </p>
                    </ul>
                    <!-- <div class="audience-btn">  -->
                    <!-- <a routerLink="/" class="default-btn">Get Started</a> -->
                    <!-- </div> -->
                </div>
            </div>
        </div>
    </div>

    <div class="default-shape">
        <div class="shape-1"><img src="assets/img/shape/4.png" alt="image"></div>
        <div class="shape-2 rotateme"><img src="assets/img/shape/5.svg" alt="image"></div>
        <div class="shape-3"><img src="assets/img/shape/6.svg" alt="image"></div>
        <div class="shape-4"><img src="assets/img/shape/7.png" alt="image"></div>
        <div class="shape-5"><img src="assets/img/shape/8.png" alt="image"></div>
    </div>
</section>

<section class="solutions-section pb-100">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-12">
                <div class="solutions-content-area">
                    <div class="solutions-content">
                        <h3>Our <span style="color: #D11717;">Featured</span> Solutions</h3>
                        <div class="bar" style="background-color: #D11717;"></div>
                        <p>At Alphurious Technologies, we offer end-to-end software development services tailored to
                            your business needs. Whether you're a startup or an enterprise, our solutions are designed
                            to deliver innovation, efficiency, and scalable performance.</p>
                    </div>
                    <!-- <div class="solutions-details">
                        <div class="icon">
                            <i class="flaticon-blog"></i>
                        </div>
                        <h3>Custom Software Development</h3>
                        <p>Build powerful, secure, and scalable applications—exactly the way you envision. From web to
                            desktop and mobile platforms, we bring your ideas to life.</p>
                    </div> -->
                    <div class="solutions-details">
                        <div class="icon bg-d3fbf9">
                            <i class="flaticon-software"></i>
                        </div>
                        <h3>Mobile App Development</h3>
                        <p>We create feature-rich Android and iOS apps that deliver seamless user experiences, strong
                            performance, and high security.</p>
                    </div>
                    <div class="solutions-details">
                        <div class="icon bg-fce8c9">
                            <i class="flaticon-analysis"></i>
                        </div>
                        <h3>Web & Desktop Application Development</h3>
                        <p>Get fast, responsive, and SEO-optimized web & desktop solutions for your business—from eCommerce
                            platforms to enterprise portals.</p>
                    </div>
                    <div class="solutions-details">
                        <div class="icon bg-d5e6fe">
                            <i class="flaticon-laptop"></i>
                        </div>
                        <h3>Cloud Solutions</h3>
                        <p>Accelerate your digital transformation with our robust cloud application development,
                            migration, and DevOps services.</p>
                    </div>
                    <div class="solutions-details">
                        <div class="icon bg-d5e6fe">
                            <i class="flaticon-laptop"></i>
                        </div>
                        <h3>AI & Automation Services</h3>
                        <p>Integrate AI into your processes to improve efficiency, reduce errors, and unlock smart
                            decision-making with predictive analytics, chatbots, and intelligent automation.</p>
                    </div>
                    <!-- <div class="solutions-details">
                        <div class="icon bg-d5e6fe">
                            <i class="flaticon-laptop"></i>
                        </div>
                        <h3>Healthcare IT Solutions</h3>
                        <p>Leverage our deep expertise in EHR, EMR, telehealth, and HIPAA-compliant systems built for
                            clinics, hospitals, and health-tech startups.</p>
                    </div> -->
                    <!-- <div class="solutions-details">
                        <div class="icon bg-d5e6fe">
                            <i class="flaticon-laptop"></i>
                        </div>
                        <h3>E-commerce Solutions</h3>
                        <p>Launch and grow your online store with our custom Shopify, WooCommerce, and Magento
                            development solutions tailored for sales and scale.</p>
                    </div> -->
                    <div class="solutions-details">
                        <div class="icon bg-d5e6fe">
                            <i class="flaticon-laptop"></i>
                        </div>
                        <h3>Maintenance & Support</h3>
                        <p>We don’t just build—it’s our priority to keep your systems secure, updated, and performing at
                            their best with ongoing support and maintenance.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-12 pr-0">
                <div class="solutions-image">
                    <img src="assets/img/solutions.png" alt="image">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="design-section pb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="design-image">
                    <img src="assets/img/design.png" alt="image">
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="design-content">
                    <h3>Our <span style="color: #D11717;">Tech-Stack</span></h3>
                    <div class="bar" style="background-color: #D11717;"></div>
                    <p>We develop Websites, Mobile & Windows Apps using below tech-stacks.</p>
                    <ul class="design-list">
                        <li><i class="flaticon-check"></i> Angular</li>
                        <li><i class="flaticon-check"></i> ReactJs</li>
                        <li><i class="flaticon-check"></i> Microsoft .NET</li>
                        <li><i class="flaticon-check"></i> Responsive Design</li>
                        <li><i class="flaticon-check"></i> UI/UX Design</li>
                        <li><i class="flaticon-check"></i> Flutter</li>
                        <li><i class="flaticon-check"></i> MERN</li>
                        <li><i class="flaticon-check"></i> MVC</li>
                        <li><i class="flaticon-check"></i> UWP</li>
                        <li><i class="flaticon-check"></i> AI</li>
                        <li><i class="flaticon-check"></i> Machine Learning</li>
                        <li><i class="flaticon-check"></i> Python</li>
                        <li><i class="flaticon-check"></i> Java</li>
                        <li><i class="flaticon-check"></i> Cloud Computing</li>
                        <li><i class="flaticon-check"></i> Data Engineering</li>
                        <li><i class="flaticon-check"></i> Data Analytics</li>
                        <li><i class="flaticon-check"></i> Azure</li>
                        <li><i class="flaticon-check"></i> Power BI</li>

                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="default-shape">
        <div class="shape-1"><img src="assets/img/shape/4.png" alt="image"></div>
        <div class="shape-2 rotateme"><img src="assets/img/shape/5.svg" alt="image"></div>
        <div class="shape-3"><img src="assets/img/shape/6.svg" alt="image"></div>
        <div class="shape-4"><img src="assets/img/shape/7.png" alt="image"></div>
        <div class="shape-5"><img src="assets/img/shape/8.png" alt="image"></div>
    </div>
</section>

<section class="counter-section pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>We have Completed <span style="color: #D11717;">10+</span> Projects <span style="color: #D11717;">Successfully</span></h2>
        </div>
        <div class="row align-items-center justify-content-center">
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-counter">
                    <div class="icon">
                        <i class="flaticon-check"></i>
                    </div>
                    <h3><span class="odometer" data-count="9">00</span></h3>
                    <p>Completed Project</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-counter">
                    <div class="icon">
                        <i class="flaticon-happy"></i>
                    </div>
                    <h3><span class="odometer" data-count="4">00</span></h3>
                    <p>Happy Clients</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-counter">
                    <div class="icon">
                        <i class="flaticon-technical-support"></i>
                    </div>
                    <h3><span class="odometer" data-count="7">00</span></h3>
                    <p>Multi Service</p>
                </div>
            </div>


            <!-- <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-counter">
                    <div class="icon">
                        <i class="flaticon-trophy"></i>
                    </div>
                    <h3><span class="odometer" data-count="750">00</span></h3>
                    <p>Winning Awards</p>
                </div>
            </div> -->
        </div>
    </div>
</section>

<section class="team-section pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>Our <span style="color: #D11717;">leadership</span></h2>
            <p style="max-width: 650px;">Behind every successful solution is a visionary team. Our leadership brings
                years of industry experience,
                innovation, and commitment to delivering world-class IT services. They drive our mission to empower
                businesses through technology.</p>
            <div class="bar" style="background-color: #D11717;"></div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="team-item">
                    <div class="image">
                        <img src="assets/img/team/KusumLata1.png" alt="image">
                        <ul class="social">
                            <li><a href="https://www.facebook.com/profile.php?id=61576226404146" target="_blank"><i
                                        class="bx bxl-facebook"></i></a></li>
                            <!-- <li><a href="#" target="_blank"><i class="bx bxl-twitter"></i></a></li> -->
                            <li><a href="https://www.linkedin.com/in/kusum-lata-05b78936a/" target="_blank"><i
                                        class="bx bxl-linkedin"></i></a></li>
                            <!-- <li><a href="#" target="_blank"><i class="bx bxl-instagram"></i></a></li> -->
                        </ul>
                    </div>
                    <div class="content">
                        <h3>KUSUM LATA</h3>
                        <span style="color: #D11717;">Director</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="team-item">
                    <div class="image">
                        <img src="assets/img/team/SonamSachdeva.png" alt="image">
                        <ul class="social">
                            <li><a href="https://www.facebook.com/profile.php?id=61576226404146" target="_blank"><i
                                        class="bx bxl-facebook"></i></a></li>
                            <!-- <li><a href="#" target="_blank"><i class="bx bxl-twitter"></i></a></li> -->
                            <li><a href="https://www.linkedin.com/in/sonam-sachdeva-89437b61/" target="_blank"><i
                                        class="bx bxl-linkedin"></i></a></li>
                            <!-- <li><a href="#" target="_blank"><i class="bx bxl-instagram"></i></a></li> -->
                        </ul>
                    </div>
                    <div class="content">
                        <h3>SONAM</h3>
                        <span style="color: #D11717;">Director</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 offset-sm-3 offset-lg-0">
                <div class="team-item">
                    <div class="image">
                        <img src="assets/img/team/PujaKumari.png" alt="image">
                        <ul class="social">
                            <li><a href="https://www.facebook.com/profile.php?id=61576226404146" target="_blank"><i
                                        class="bx bxl-facebook"></i></a></li>
                            <!-- <li><a href="#" target="_blank"><i class="bx bxl-twitter"></i></a></li> -->
                            <li><a href="https://www.linkedin.com/in/puja-kumari-0b666a327/" target="_blank"><i
                                        class="bx bxl-linkedin"></i></a></li>
                            <!-- <li><a href="#" target="_blank"><i class="bx bxl-instagram"></i></a></li> -->
                        </ul>
                    </div>
                    <div class="content">
                        <h3>PUJA KUMARI</h3>
                        <span style="color: #D11717;">Director</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="default-shape">
        <div class="shape-1"><img src="assets/img/shape/4.png" alt="image"></div>
        <div class="shape-2 rotateme"><img src="assets/img/shape/5.svg" alt="image"></div>
        <div class="shape-3"><img src="assets/img/shape/6.svg" alt="image"></div>
        <div class="shape-4"><img src="assets/img/shape/7.png" alt="image"></div>
        <div class="shape-5"><img src="assets/img/shape/8.png" alt="image"></div>
    </div>
</section>

<!-- <section class="pricing-section pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>Our <span>Pricing</span> Plan</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incidiunt labore et dolore magna aliqua.</p>
            <div class="bar" style="background-color: #D11717;"></div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-pricing">
                    <div class="pricing-header">
                        <h3>Basic</h3>
                        <p>Business Up</p>
                    </div>
                    <div class="price">
                        <sup>$</sup>29<sub>/mo</sub>
                    </div>
                    <ul class="pricing-list">
                        <li><i class="flaticon-checked"></i> 10 GB Hosting </li>
                        <li><i class="flaticon-checked"></i> 2 Unique Users </li>
                        <li><i class="flaticon-checked"></i> 12 GB Capacity</li>
                        <li><i class="flaticon-cancel"></i> Any Where Access</li>
                        <li><i class="flaticon-cancel"></i> Weekly Backup</li>
                        <li><i class="flaticon-cancel"></i> Support 24/Hour</li>
                    </ul>
                    <div class="price-btn">
                        <a routerLink="/" class="default-btn">Buy Now</a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-pricing">
                    <div class="pricing-header">
                        <h3>Standard</h3>
                        <p>Business Up</p>
                    </div>
                    <div class="price">
                        <sup>$</sup>79<sub>/mo</sub>
                    </div>
                    <ul class="pricing-list">
                        <li><i class="flaticon-checked"></i> Visitor Info</li>
                        <li><i class="flaticon-checked"></i> Quick Responses</li>
                        <li><i class="flaticon-checked"></i> 12 GB Capacity</li>
                        <li><i class="flaticon-checked"></i> Any Where Access</li>
                        <li><i class="flaticon-cancel"></i> Weekly Backup</li>
                        <li><i class="flaticon-cancel"></i> Support 24/Hour</li>
                    </ul>
                    <div class="price-btn">
                        <a routerLink="/" class="default-btn">Buy Now</a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                <div class="single-pricing">
                    <div class="pricing-header">
                        <h3>Premium</h3>
                        <p>Business Up</p>
                    </div>
                    <div class="price">
                        <sup>$</sup>99<sub>/mo</sub>
                    </div>
                    <ul class="pricing-list">
                        <li><i class="flaticon-checked"></i> 10 GB Hosting </li>
                        <li><i class="flaticon-checked"></i> 2 Unique Users </li>
                        <li><i class="flaticon-checked"></i> 12 GB Capacity</li>
                        <li><i class="flaticon-checked"></i> Any Where Access</li>
                        <li><i class="flaticon-checked"></i> Weekly Backup</li>
                        <li><i class="flaticon-cancel"></i> Support 24/Hour</li>
                    </ul>
                    <div class="price-btn">
                        <a routerLink="/" class="default-btn">Buy Now</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="default-shape">
        <div class="shape-1"><img src="assets/img/shape/4.png" alt="image"></div>
        <div class="shape-2 rotateme"><img src="assets/img/shape/5.svg" alt="image"></div>
        <div class="shape-3"><img src="assets/img/shape/6.svg" alt="image"></div>
        <div class="shape-4"><img src="assets/img/shape/7.png" alt="image"></div>
        <div class="shape-5"><img src="assets/img/shape/8.png" alt="image"></div>
    </div>
</section> -->

<section class="protfolio-section pt-50 pb-70">
    <!-- <div class="container"> -->
        <div class="section-title">
            <h2>Our <span style="color: #D11717;">Impressive</span> Portfolio</h2>
            <p>A showcase of our expertise—real results delivered across diverse industries through innovative,
                high-performing solutions.</p>
            <div class="bar" style="background-color: #D11717;"></div>
        </div>
    <div class="portfolio-grid">
        <div class="portfolio-card" 
             *ngFor="let projectId of projectKeys"
             [attr.data-category]="projects[projectId].category.toLowerCase().replace(' ', '')"
             [style.display]="currentFilter === 'all' || projects[projectId].category.toLowerCase().includes(currentFilter) ? 'block' : 'none'">

            <div *ngIf="projectId === 'healthcare1'" class="card-image healthcare-bg" (click)="openModal(projectId)">
                <i class="fas fa-hospital-user"></i>
                <div class="card-overlay">
                    <button class="view-btn">View Details <i class="fas fa-arrow-right"></i></button>
                </div>
            </div>
            <div *ngIf="projectId === 'healthcare1'" class="card-content">
                <div class="card-tags"><span class="tag">EHR</span><span class="tag">HIPAA</span><span class="tag">Cloud</span></div>
                <h4>Healthcare Software & Digital Health Solutions</h4>
                <p>Streamlined patient care with integrated scheduling, records, and billing.</p>
                <div class="card-footer">
                    <div class="tech-stack">
                        <span><i class="fab fa-react"></i></span>
                        <span><i class="fab fa-node-js"></i></span>
                        <span><i class="fas fa-database"></i></span>
                        <span><i class="fa-brands fa-microsoft"></i></span>
                        <span><i class="fas fa-code"></i></span>
                        <span><i class="fa-brands fa-angular"></i></span>
                    </div>
                    <span class="project-status completed">Completed</span>
                </div>
            </div>

            <div *ngIf="projectId === 'healthcare2'" class="card-image healthcare-bg-2" (click)="openModal(projectId)">
                <i class="fas fa-video"></i>
                <div class="card-overlay">
                    <button class="view-btn">View Details <i class="fas fa-arrow-right"></i></button>
                </div>
            </div>
            <div *ngIf="projectId === 'healthcare2'" class="card-content">
                <div class="card-tags"><span class="tag">Telehealth</span><span class="tag">Video</span><span class="tag">Secure</span></div>
                <h4>Telemedicine Platform</h4>
                <p>Connect patients with healthcare providers through secure video consultations.</p>
                <div class="card-footer">
                    <div class="tech-stack">
                        <span><i class="fas fa-broadcast-tower"></i></span>
                        <span><i class="fab fa-react"></i></span>
                        <span><i class="fab fa-node-js"></i></span>
                        <span><i class="fas fa-database"></i></span>
                        <span><i class="fa-brands fa-microsoft"></i></span>
                        <span><i class="fas fa-code"></i></span>
                        <span><i class="fa-brands fa-angular"></i></span>
                    </div>
                    <span class="project-status in-progress">In Progress</span>
                </div>
            </div>

            <div *ngIf="projectId === 'grocery1'" class="card-image grocery-bg" (click)="openModal(projectId)">
                <i class="fas fa-boxes-stacked"></i>
                <div class="card-overlay">
                    <button class="view-btn">View Details <i class="fas fa-arrow-right"></i></button>
                </div>
            </div>
            <div *ngIf="projectId === 'grocery1'" class="card-content">
                <div class="card-tags"><span class="tag">Azure</span><span class="tag">Inventory</span><span class="tag">Analytics</span></div>
                <h4>Smart Inventory System</h4>
                <p>Reduce waste and optimize stock levels with predictive analytics.</p>
                <div class="card-footer">
                    <div class="tech-stack">
                        <span><i class="fab fa-react"></i></span>
                        <span><i class="fab fa-node-js"></i></span>
                        <span><i class="fas fa-database"></i></span>
                        <span><i class="fa-brands fa-microsoft"></i></span>
                        <span><i class="fas fa-code"></i></span>
                        <span><i class="fa-brands fa-angular"></i></span>
                        <span><i class="fas fa-cloud"></i></span>
                    </div>
                    <span class="project-status in-progress">In Progress</span>
                </div>
            </div>

            <div *ngIf="projectId === 'grocery2'" class="card-image grocery-bg-2" (click)="openModal(projectId)">
                <i class="fas fa-shopping-cart"></i>
                <div class="card-overlay">
                    <button class="view-btn">View Details <i class="fas fa-arrow-right"></i></button>
                </div>
            </div>
            <div *ngIf="projectId === 'grocery2'" class="card-content">
                <div class="card-tags"><span class="tag">E-Commerce</span><span class="tag">Mobile</span><span class="tag">React Native</span></div>
                <h4>E-Commerce Platform</h4>
                <p>Seamless online shopping with real-time delivery tracking.</p>
                <div class="card-footer">
                    <div class="tech-stack">
                        <span><i class="fab fa-stripe"></i></span>
                        <span><i class="fab fa-react"></i></span>
                        <span><i class="fab fa-node-js"></i></span>
                        <span><i class="fas fa-database"></i></span>
                        <span><i class="fa-brands fa-microsoft"></i></span>
                        <span><i class="fas fa-code"></i></span>
                        <span><i class="fa-brands fa-angular"></i></span>
                    </div>
                    <span class="project-status completed">Completed</span>
                </div>
            </div>

            <div *ngIf="projectId === 'data1'" class="card-image data-bg" (click)="openModal(projectId)">
                <i class="fas fa-chart-pie"></i>
                <div class="card-overlay">
                    <button class="view-btn">View Details <i class="fas fa-arrow-right"></i></button>
                </div>
            </div>
            <div *ngIf="projectId === 'data1'" class="card-content">
                <div class="card-tags"><span class="tag">BI</span><span class="tag">ETL</span><span class="tag">Analytics</span><span class="tag">Dashboard</span></div>
                <h4>Business Intelligence Dashboard</h4>
                <p>Transform raw data into actionable business insights.</p>
                <div class="card-footer">
                    <div class="tech-stack">
                        <span><i class="fas fa-chart-bar"></i></span>
                        <span><i class="fa-solid fa-chart-column"></i></span>
                        <span><i class="fas fa-database"></i></span>
                        <span><i class="fab fa-python"></i></span>
                        <span><i>Azure</i></span>
                    </div>
                    <span class="project-status in-progress">In Progress</span>
                </div>
            </div>

            <div *ngIf="projectId === 'automotive1'" class="card-image data-bg-2" (click)="openModal(projectId)">
                <i class="fas fa-car"></i>
                <div class="card-overlay">
                    <button class="view-btn">View Details <i class="fas fa-arrow-right"></i></button>
                </div>
            </div>
            <div *ngIf="projectId === 'automotive1'" class="card-content">
                <div class="card-tags"><span class="tag">React Native</span><span class="tag">Mobile</span><span class="tag">CDN</span></div>
                <h4>Vehicle Marketplace Platform</h4>
                <p>Robust data infrastructure for seamless data flow.</p>
                <div class="card-footer">
                    <div class="tech-stack">
                        <span><i class="fab fa-react"></i></span>
                        <span><i class="fab fa-node-js"></i></span>
                        <span><i class="fas fa-database"></i></span>
                        <span><i class="fa-brands fa-microsoft"></i></span>
                        <span><i class="fas fa-code"></i></span>
                        <span><i class="fa-brands fa-angular"></i></span>
                    </div>
                    <span class="project-status in-progress">In Progress</span>
                </div>
            </div>

        </div>
    </div>
          <div id="projectModal" class="modal" [ngClass]="{'active': isModalOpen}" (click)="closeModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
        <button class="modal-close" (click)="closeModal()">&times;</button>
        <div id="modalBody" *ngIf="selectedProject">
            <div class="modal-header">
                <span class="category-badge">{{ selectedProject.category }}</span>
                <h2>{{ selectedProject.title }}</h2>
                <p>{{ selectedProject.subtitle }}</p>
            </div>
            <div class="modal-body">
                <div class="modal-section">
                    <h3><i class="fas fa-info-circle"></i> Overview</h3>
                    <p>{{ selectedProject.overview }}</p>
                </div>
                <div class="modal-section">
                    <h3><i class="fas fa-list-check"></i> Key Features</h3>
                    <ul>
                        <li *ngFor="let feature of selectedProject.features"><i class="fas fa-check-circle"></i> {{ feature }}</li>
                    </ul>
                </div>
                <div class="modal-section">
                    <h3><i class="fas fa-code"></i> Technologies Used</h3>
                    <div class="modal-tech">
                        <span *ngFor="let tech of selectedProject.technologies">{{ tech }}</span>
                    </div>
                </div>
                <!-- <div class="modal-section">
                    <h3><i class="fas fa-trophy"></i> Results</h3>
                    <div class="modal-results"><p>{{ selectedProject.results }}</p></div>
                </div> -->
                <div class="modal-section">
    <h3><i class="fas fa-trophy"></i> Results</h3>
<div class="modal-results">
    <!-- If results is a single string -->
    <p *ngIf="!isResultsArray(selectedProject?.results)">
        {{ selectedProject?.results }}
    </p>

    <!-- If results is an array -->
    <ul *ngIf="isResultsArray(selectedProject?.results)">
        <li *ngFor="let result of selectedProject?.results">
            <i class="fas fa-check-circle"></i> {{ result }}
        </li>
    </ul>
    </div>
</div>

                <div class="modal-section">
                    <h3><i class="fas fa-images"></i> Project Gallery</h3>
                    <div class="modal-gallery">
                        <img *ngFor="let img of selectedProject.images" [src]="img" alt="Project screenshot">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>  
    <!-- </div> -->
    </section>




<!-- <section class="clients-section">
    <div class="container">
        <div class="section-title">
            <h2>What Our <span>Clients</span> Says</h2>
            <p>Trusted by businesses worldwide—hear how our solutions have made a difference.
            <p>Trusted by businesses worldwide—hear how our solutions have made a difference.
            </p>
            <div class="bar" style="background-color: #D11717;"></div>
        </div>
        <div class="clients-slider owl-carousel owl-theme">
            <div class="clients-item">
                <div class="icon">
                    <i class="flaticon-left-quotes-sign"></i>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, printing printing sed do eiusmod tempor
                    incididunt ut labore et printing dolore magna aliqua. Quis ipsum printing suspendisse ultricesss
                    gravida. Risus commodo viverra printing maecenas accumsan lacus vel facilisis printing. Lorem Ipsum
                    is simply dummy text of the printing and typesetting industry.</p>
                <div class="clients-content">
                    <h3>Moris Jacker</h3>
                    <span>Web Developer</span>
                </div>
            </div>
            <div class="clients-item">
                <div class="icon">
                    <i class="flaticon-left-quotes-sign"></i>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, printing printing sed do eiusmod tempor
                    incididunt ut labore et printing dolore magna aliqua. Quis ipsum printing suspendisse ultricesss
                    gravida. Risus commodo viverra printing maecenas accumsan lacus vel facilisis printing. Lorem Ipsum
                    is simply dummy text of the printing and typesetting industry.</p>
                <div class="clients-content">
                    <h3>Alex Maxwel</h3>
                    <span>Agent Management</span>
                </div>
            </div>
            <div class="clients-item">
                <div class="icon">
                    <i class="flaticon-left-quotes-sign"></i>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, printing printing sed do eiusmod tempor
                    incididunt ut labore et printing dolore magna aliqua. Quis ipsum printing suspendisse ultricesss
                    gravida. Risus commodo viverra printing maecenas accumsan lacus vel facilisis printing. Lorem Ipsum
                    is simply dummy text of the printing and typesetting industry.</p>
                <div class="clients-content">
                    <h3>Edmond Halley</h3>
                    <span>Web Designer</span>
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- <section class="blog-section pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>Our <span>Latest</span> News</h2>
            <p>Stay updated with the latest innovations, insights, and achievements shaping the future of IT solutions
                at Alphurious Technology</p>
            <div class="bar" style="background-color: #D11717;"></div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-item">
                    <div class="image">
                        <a routerLink="/blog-details"><img src="assets/img/blog/HealthCareWearables.png"
                                alt="image"></a>
                    </div>
                    <div class="content">
                        <span>9 June 2025</span>
                        <h3><a routerLink="/blog-details">𝐏𝐫𝐞𝐯𝐞𝐧𝐭𝐢𝐯𝐞 𝐇𝐞𝐚𝐥𝐭𝐡𝐜𝐚𝐫𝐞: 𝐒𝐭𝐨𝐩
                                𝐈𝐥𝐥𝐧𝐞𝐬𝐬 𝐁𝐞𝐟𝐨𝐫𝐞 𝐈𝐭 𝐒𝐭𝐚𝐫𝐭𝐬 </a></h3>
                        <p>From health-tracking wearables to remote diagnostics, technology is making healthcare
                            proactive, not reactive</p>
                        <a routerLink="/blog-details" class="read-more">Read More</a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-item">
                    <div class="image">
                        <a routerLink="/blog-details"><img src="assets/img/blog/img2.jpg" alt="image"></a>
                    </div>
                    <div class="content">
                        <span>25 April 2023</span>
                        <h3><a routerLink="/blog-details">The Billionaire Guide On Design That will Get You Rich</a>
                        </h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor</p>
                        <a routerLink="/blog-details" class="read-more">Read More</a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                <div class="single-blog-item">
                    <div class="image">
                        <a routerLink="/blog-details"><img src="assets/img/blog/img3.jpg" alt="image"></a>
                    </div>
                    <div class="content">
                        <span>30 July 2023</span>
                        <h3><a routerLink="/blog-details">Making Peace With The Feast Or Famine Of Freelancing</a></h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor</p>
                        <a routerLink="/blog-details" class="read-more">Read More</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->
</html>